import React from 'react'

import PropTypes from 'prop-types'

import './footer4.css'

const Footer4 = (props) => {
  return (
    <footer className="footer4-footer7 thq-section-padding">
      <span>{props.text1}</span>
      <div className="footer4-max-width thq-section-max-width">
        <div className="footer4-content">
          <div className="footer4-logo"></div>
          <div className="footer4-links"></div>
        </div>
        <div className="footer4-credits">
          <div className="thq-divider-horizontal"></div>
          <div className="footer4-row">
            <div className="footer4-container">
              <span className="thq-body-small">
                <span>
                  © 2024
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <br></br>
              </span>
            </div>
            <div className="footer4-footer-links"></div>
          </div>
        </div>
      </div>
    </footer>
  )
}

Footer4.defaultProps = {
  termsLink: 'Terms and Conditions',
  link1: 'Home',
  link5:
    'Ivana Šulcová, IČ: 43895069 Černého 429/2, 182 00, Praha 8 - Střížkov',
  cookiesLink: 'Cookies Policy',
  text1:
    'Ivana Šulcová, IČ: 43895069 Černého 429/2, 182 00, Praha 8 - Střížkov',
  logoSrc: 'https://presentation-website-assets.teleporthq.io/logos/logo.png',
  link2: 'Services',
  link3: 'About Us',
  logoAlt: 'Numerology Services Logo',
  link4: 'Contact Us',
  privacyLink: 'Privacy Policy',
  text: 'Text',
}

Footer4.propTypes = {
  termsLink: PropTypes.string,
  link1: PropTypes.string,
  link5: PropTypes.string,
  cookiesLink: PropTypes.string,
  text1: PropTypes.string,
  logoSrc: PropTypes.string,
  link2: PropTypes.string,
  link3: PropTypes.string,
  logoAlt: PropTypes.string,
  link4: PropTypes.string,
  privacyLink: PropTypes.string,
  text: PropTypes.string,
}

export default Footer4
